export enum LoginWithPasswordFormFieldNames {
  username = "username",
  password = "password"
}

export type LoginWithPasswordFormFieldValues = {
  [LoginWithPasswordFormFieldNames.username]: string
  [LoginWithPasswordFormFieldNames.password]: string
}